/**
 * Deferred Script Loader
 *
 * @namespace Deferred
 * @aka SWRNEU.Deferred
 */
SWRNEU.Deferred = (function ($) {
  //Mit dieser Variable werden die Debug-Ausgaben in der Konsole ein-/ausgeschaltet,
  //da es sehr viele werden können. Hilfreich können sie aber durchaus sein.
  var enableDebugMode = false;

  /*
   * configuration
   */
  var configs = {

    //Back to Top Button
    '#back-to-top-button': {
      css: ['swr-neu-back-to-top.min.css'],
      observe: false
    },

    //Bildergalerie
    '[data-spy="gallery"]': {
      js: ['swr-neu-page-indicator.min.js', 'swr-neu-gallery.min.js'],
      observe: true
    },

    // Lightbox / Fullscreen
    '.bodytext > figure.asset-image, .info-box-content > figure.asset-image, [data-toggle="fullscreen"]': {
      js: ['swr-neu-lightbox.min.js'],
      observe: true
    },

    //Radio-Teaser
    '.frontmod-radioteaser': {
      css: ['swr-neu-radio-teaser.min.css', 'swr-neu-radio-common.min.css'],
      js: ['swr-neu-radio-teaser.min.js'],
      observe: true
    },

    //Countdown
    '[data-spy="countdown"],[data-id*="countdown"]': {
      css: ['swr-neu-countdown.min.css'],
      js: ['swr-neu-countdown.min.js'],
      observe: true
    },

    //Kopieren in die Zwischenablage
    '[data-spy="clipboard"]': {
      css: ['swr-neu-toast.min.css'],
      js: ['common-clipboard.min.js', 'common-toast.min.js'],
      observe: true
    },

    // ==== Formulare ======
    //Formular-Styling
    'form.form': {
      css: ['swr-neu-formular.min.css'],
      observe: true
    },

    // Upload-Formularfeld
    '[data-upload-service-field]': {
      js: ['swr-neu-ugc-media-upload.min.js'],
      observe: true
    },
    //Formularvalidierung
    '[data-spy="validate"]': {
      css: ['swr-neu-toast.min.css'],
      js: ['common-toast.min.js', 'common-validate.min.js', 'swr-neu-form-submit-overlay.min.js'],
      observe: true
    },
    'textarea[maxlength],textarea[minlength]': {
      js: ['common-countCharacters.min.js'],
      observe: true
    },

    '[type="file"]': {
      css: ['swr-neu-formular.min.css'],
      js: ['swr-neu-fileUpload.min.js', 'swr-neu-formStyle.min.js'],
      observe: true
    },
    // FriendlyCaptcha
    'form [data-spy=friendlycaptcha]': {
      css: ['common-friendlycaptcha.min.css'],
      js: ['common-frcaptcha.min.js'],
      observe: true
    },
    'form[data-prefill]': {
      js: ['common-formPrefill.min.js'],
      observe: true
    },
    '[type="date"]:not([name$="memorable-date"])': {
      css: ['swr-neu-datepicker.min.css', 'swr-neu-formular.min.css'],
      js: ['swr-neu-datePicker.min.js', 'swr-neu-formStyle.min.js'],
      observe: true
    },
    'input[name$="_map"], input[name$="_map(v)"], .form-group-mappicker': {
      css: ['common-leaflet.min.css', 'swr-neu-leaflet.min.css', 'swr-neu-mappicker.min.css', 'swr-neu-formular.min.css'],
      js: ['common-leaflet.min.js', 'swr-neu-mappicker.min.js', 'swr-neu-formStyle.min.js'],
      observe: false
    },
    '.form,.alert-success,.alert-danger': {
      css: ['swr-neu-formular.min.css'],
      js: ['swr-neu-formStyle.min.js'],
      observe: true
    },
    '.two-searches': {
      js: ['swr-neu-dmt-suche.min.js'],
      observe: true
    },
    // MultiFieldDate
    'input[type="date"][name$="multi-field-date"]': {
      js: ['common-multifielddate.min.js'],
      observe: true
    },

    // ARD Login
    '[data-spy="ard-login"]': {
      css: ['swr-neu-ard-login.min.css', 'swr-neu-toast.min.css'],
      js: ['swr-neu-ard-login.min.js', 'common-toast.min.js'],
      observe: true
    },

    //Personalisierungsblock
    '.personalization-carousel': {
      css: ['swr-neu-ard-login-personalization-block.min.css'],
      js: ['swr-neu-ard-login-personalization-block.min.js'],
      observe: true
    },

    //Mein SWR
    '[data-spy="my-swr"]': {
      css: ['swr-neu-ard-login-my-swr.min.css', 'swr-neu-ard-login-onboarding.min.css'],
      js: ['swr-neu-ard-login-my-swr.min.js', 'swr-neu-ard-login-onboarding.min.js'],
      observe: true
    },

    '[data-spy="bookmarks"]': {
      css: ['swr-neu-ard-login-bookmarks.min.css'],
      js: ['swr-neu-ard-login-bookmarks.min.js'],
      observe: true
    },

    '[data-spy="login-settings"]': {
      css: ['swr-neu-ard-login-settings.min.css'],
      js: ['swr-neu-ard-login-settings.min.js'],
      observe: true
    },

    '[data-spy="region-search"]': {
      css: ['swr-neu-ard-login-region-search.min.css'],
      js: ['swr-neu-ard-login-region-search.min.js'],
      observe: true
    },

    //Paginierung
    '.pagination:not([data-spy="js-pagination"])': {
      css: ['swr-neu-paginierung.min.css'],
      js: ['swr-neu-paginierung.min.js'],
      observe: true
    },

    //JS-Paginierung
    '[data-spy="js-pagination"]': {
      css: ['swr-neu-paginierung.min.css'],
      js: ['swr-neu-js-paginierung.min.js'],
      observe: true
    },

    //Interaktionsleiste
    '[data-spy="interaction-bar"]': {
      css: ['swr-neu-formular.min.css', 'swr-neu-toast.min.css'],
      js: ['swr-neu-interaction-bar.min.js', 'common-toast.min.js'],
      observe: true
    },

    //Karussell
    '[data-spy="teasercarousel"]': {
      js: ['swr-neu-page-indicator.min.js', 'swr-neu-teaserkarussell.min.js'],
      observe: true
    },
    '.carousel.highlight [data-spy="teasercarousel"]': {
      js: ['swr-neu-page-indicator.min.js', 'swr-neu-highlight-karussell.min.js'],
      observe: true
    },

    //Kommentare
    'section.comments-section,[data-spy="comment-wrapper"]': {
      css: ['swr-neu-comment.min.css', 'swr-neu-formular.min.css', 'common-friendlycaptcha.min.css', 'swr-neu-toast.min.css'],
      js: ['swr-neu-comment.min.js', 'common-frcaptcha.min.js', 'common-countCharacters.min.js', 'common-validate.min.js', 'common-toast.min.js'],
      observe: true
    },

    //Videoplayer
    '[data-spy="mediaplayer"]': {
      css: ['swr-neu-ardplayer.min.css'],
      js: ['../ardplayer/7.18.0/ardplayer.js', 'swr-neu-videoplayer.min.js'],
      observe: true
    },

    //Player in Teasern
    '[data-spy=teaser-mediaplayer]': {
      css: ['swr-neu-ardplayer.min.css'],
      js: ['../ardplayer/7.18.0/ardplayer.js', 'swr-neu-videoplayer.min.js'],
      observe: false
    },

    //Bing-Maps
    '[data-toggle="eventmap"]': {
      css: ['common-leaflet.min.css'],
      js: ['common-leaflet.min.js', 'swr-neu-eventmap.min.js'],
      observe: true
    },

    // für `[hidden=until-found]`
    '[data-toggle="collapse"]': {
      js: ['common-collapse-helper.min.js'],
      observe: true
    },

    // Rezepte
    '[id=recipe]': {
      css: ['swr-recipe-neu.min.css'],
      observe: true
    },

    // Quiz
    '[data-spy="quiz"]': {
      css: ['swr-neu-quiz.min.css'],
      js: ['swr-neu-quiz.min.js'],
      observe: true
    },

    // Voting
    '[data-spy="voting"]': {
      css: ['swr-neu-quiz.min.css'],
      js: ['swr-neu-quiz.min.js'],
      observe: true
    },

    // Voicerecorder
    'form:has(textarea[name="formField_nachricht"]):has(input[type="hidden"][name="formField_programId"]) input[type="file"][name$="formField_asset"]': {
      css: ["swr-neu-voicerecorder.min.css"],
      js: ["swr-neu-floating-ui.min.js", "swr-neu-voicerecorder.min.js"],
      observe: true,
    },

    //Liveblog
    '[data-spy="liveblog"]': {
      css: ['swr-neu-toast.min.css'],
      js: ['swr-neu-liveblog.min.js', 'common-toast.min.js'],
      observe: true
    },

    //Programmkalender
    '.form-program-calendar,.episodes-list': {
      css: ['swr-neu-programmkalender-episodes.min.css'],
      js: ['swr-neu-programmkalender-episodes.min.js'],
      observe: true
    },
    '.nav-program-calendar, .nav-program-stations': {
      css: ['swr-neu-programmkalender.min.css'],
      js: ['swr-neu-programmkalender.min.js'],
      observe: true
    },

    //Switch
    '.switch': {
      css: ['swr-neu-switch.min.css'],
      observe: true
    },

    //Zwei-Klick-Lösung
    '[data-spy="embed"]': {
      css: ['swr-neu-switch.min.css', 'swr-neu-social.min.css'],
      js: ['swr-neu-switch.min.js', 'swr-neu-social.min.js'],
      observe: true
    },

    //Embeds ohne Zwei-Klick-Lösung
    'iframe[data-embed-type="datawrapper"]': {
      js: ['swr-neu-datawrapper.min.js', '../iframe-resizer/v4.3.1/iframeResizer.min.js', 'swr-neu-iframeResize.min.js'],
      observe: true
    },

    'iframe[data-spy="iframe-resize"],iframe[data-embed-type="infratest"]': {
      js: ['../iframe-resizer/v4.3.1/iframeResizer.min.js', 'swr-neu-iframeResize.min.js'],
      observe: true
    },

    'iframe.tagesschau-embed[data-embed-type=iframe]': {
      js: ['swr-neu-tagesschau-embed.min.js'],
      observe: true
    },

    'div[data-embed-type="textgenerator"]': {
      js: ['swr-neu-textgenerator.min.js'],
      observe: true
    },

    //das Wetter - generell
    '.weather-cnt, .weather-cnt-new': {
      css: ['swr-neu-wetter.min.css'],
      observe: true
    },

    //das Wetter - Diagramm
    '[data-spy="chart"]': {
      js: ['swr-neu-chart.min.js'],
      observe: true
    },

    // Unwetterkarte
    '[data-spy=unwetter]': {
      css: ['common-leaflet.min.css', 'swr-neu-unwetter.min.css'],
      js: ['common-leaflet.min.js', 'common-unwetter.min.js', 'swr-neu-unwetter.min.js'],
      observe: true
    },

    //Audioplayer in der Musikrecherche
    '[data-spy="audioplayer"]:not(button)': {
      css: ['swr-neu-audioplayer-inline.min.css'],
      js: ['swr-neu-audioplayer-inline.min.js'],
      observe: true
    },

    //Musikrecherche
    '#musikrecherche-playlist': {
      css: ['swr-neu-musikrecherche.min.css'],
      js: ['swr-neu-musikrecherche.min.js'],
      observe: true
    },

    //Verkehr
    '#map-osm-wrapper': {
      css: ['common-leaflet.min.css', 'swr-neu-leaflet.min.css', 'swr-neu-traffic.min.css'],
      js: ['common-leaflet.min.js', 'common-traffic.min.js'],
      observe: true
    },
    //Frequenzsuche
    '[data-spy="freqsearch"]': {
      css: ['swr-neu-frequenzsuche.min.css'],
      js: ['swr-neu-frequenzsuche.min.js'],
      observe: true
    },
    // Suchseite
    '.suchseite': {
      css: ['swr-neu-suchseite.min.css'],
      observe: true
    },

    //Datenschutz
    '[data-spy="datenschutz"]': {
      css: ['swr-neu-switch.min.css', 'swr-neu-datenschutz.min.css'],
      js: ['swr-neu-switch.min.js', 'swr-neu-datenschutz.min.js'],
      observe: true
    },
    //Podcast
    '.panel-podcast': {
      css: ['swr-neu-podcast.min.css'],
      observe: true
    },
    //Playlist (Podcast- und Playlist-Dokument
    '.playlist-wrapper': {
      css: ['swr-neu-playlist.min.css'],
      observe: true
    },
    // Suchschlitz
    '.navbar-first-level-right.collapse.show [data-spy="search"], form.form-suche': {
      js: ['swr-neu-search.min.js'],
      observe: true
    },
    //Eventkalender
    '.form-concert-list,.concert-list,.event-list': {
      css: ['swr-neu-eventkalender.min.css'],
      observe: true
    },
    //DMT-Archiv
    '.dmt-archiv, .rubrik-dmt-archiv': {
      css: ['swr-neu-dmt-archiv.min.css'],
      observe: true
    },
    //Newsletter
    '.frontmod-schnellanmeldebox,.modal-newsletter': {
      css: ['swr-neu-newsletter.min.css'],
      observe: true
    },

    //Konfetti
    '[id*="konfetti-teaser"],[data-id*="konfetti-teaser"]': {
      js: ['swr-neu-konfetti.min.js'],
      observe: true
    },

    // Refresh
    'img[data-spy="refresh"]': {
      js: ['common-refresh.min.js'],
      observe: true
    },

    //External Links-Overlay
    'a[rel*=external]': {
      js: ['swr-neu-floating-ui.min.js', 'swr-neu-external-link.min.js'],
      observe: true,
    },

    //Copyright im Footer
    '[data-toggle="copyrights"]': {
      js: ['common-copyrights.min.js'],
      observe: true
    },

    //Playerleiste
    '#playerbar': {
      css: ['swr-neu-playerbar.min.css', 'swr-neu-radio-common.min.css'],
      js: ['swr-neu-playerbar.min.js'],
      observe: false
    },
    '#header': {
      css: ['swr-neu-header-side-menu.min.css'],
      observe: true
    },
    //Footer
    '#footer': {
      css: ['swr-neu-footer.min.css'],
      observe: true
    },

    //Legende
    '#button-legende': {
      css: ['swr-neu-legende.min.css'],
      js: ['swr-neu-legende.min.js'],
      observe: true
    }
  };

  /**
   * Liste von Skripten, die verzögert ("lazy") geladen werden sollen,
   * unabhängig von bestimmten DOM-Elementen.
   * @type {string[]}
   * @private
   */
  var lazyScripts = [];
  if (!SWRNEU.Util.isAppChannel && !window.isHerzenssache && !window.isMixtalk) {
    //Wir befinden uns nicht im App-HTML-Channel
    //und auch nicht bei der Herzenssache oder bei Mixtalk

    lazyScripts.push(...[
      { src: 'swr-neu-prefetch.min.js' },
      { src: 'swr-neu-modules.min.js', type: 'module' },
      { src: 'swr-neu-firebase-connector.min.js', type: 'module' }
    ]);
  }

  //Obige Definitionen werden überschrieben:
  if (window.isHerzenssache) {
    //Wir befinden uns bei der Herzenssache
    configs['#footer'] = {
      css: ['herzenssache-footer.min.css'],
      observe: true
    };

    configs['#playerbar'] = {};
  }

  if (window.isMixtalk) {
    //Wir befinden uns bei Mixtalk
    configs['#footer'] = {
      css: ['mixtalk-footer.min.css'],
      observe: true
    };

    configs['#playerbar'] = {};
  }

  /**
   * Lädt ein JavaScript-Asset dynamisch nach.
   *
   * Existiert bereits ein Script-Element mit der angegebenen ID,
   * wird kein weiterer Ladevorgang gestartet.
   *
   * @param {object} options Konfiguration des Skript-Loads.
   * @param {string|number} options.id Eindeutige ID des Script-Elements.
   * @param {string} options.src URL des nachzuladenden Skripts.
   * @param {function} [options.callback] Wird nach erfolgreichem Laden ausgeführt.
   * @param {string} [options.type] Optionaler Script-Typ (z.B. `module`).
   * @param {boolean} [options.async=false] Gibt an, ob das Skript asynchron geladen werden soll.
   * @param {'high' | 'low' | 'auto'} [options.fetchpriority] Lade-Priorität des Skripts.
   */
  var loadScript = function loadScript (options) {
    if (!options.id || !options.src || (typeof options.id !== 'string' && typeof options.id !== 'number') || typeof options.src !== 'string') {
      throw new Error('loadScript: `id` (String/Nummer) und `src` (String) müssen im options-Objekt vorhanden sein.', options);
    }

    // Skript wurde bereits geladen oder wird bereits geladen.
    // In diesem Fall keinen neuen Request auslösen.
    if (document.getElementById(options.id)) {
      if (typeof options.callback === 'function') {
        // Callback auch für bereits vorhandene Skripte ausführen,
        // damit sich der Aufrufer identisch verhält wie bei einem
        // tatsächlichen Ladevorgang.
        options.callback.call(undefined, true);
      }

      return;
    }

    var js = document.createElement('script');
    js.id = options.id;
    js.src = options.src;

    // Standardmäßig synchron zur Einfügereihenfolge laden.
    // Nur bei explizitem `async: true` asynchron laden.
    js.async = options.async === true;

    if (options.type) {
      js.type = options.type;
    }

    if (options.fetchpriority) {
      js.fetchpriority = options.fetchpriority;
    }

    if (typeof options.callback === 'function') {
      js.onload = options.callback;
    }

    // Script-Element in das Dokument einfügen und damit
    // den Ladevorgang starten.
    document.body.appendChild(js);
  };

  /**
   * Lädt ein CSS-Asset dynamisch nach.
   *
   * Existiert bereits ein Link-Element mit der angegebenen ID,
   * wird kein weiterer Ladevorgang gestartet.
   *
   * @param {object} options Konfiguration des CSS-Loads.
   * @param {string|number} options.id Eindeutige ID des Link-Elements.
   * @param {string} options.src URL der nachzuladenden CSS-Datei.
   * @param {function} [options.callback] Wird nach erfolgreichem Laden ausgeführt.
   * @param {string} [options.media='screen'] Media-Attribut des Stylesheets.
   * @param {'high' | 'low' | 'auto'} [options.fetchpriority] Lade-Priorität der CSS-Datei.
   */
  var loadCss = function loadCss (options) {
    if (!options.id || !options.src || (typeof options.id !== 'string' && typeof options.id !== 'number') || typeof options.src !== 'string') {
      throw new Error('loadCss: `id` (String/Nummer) und `src` (String) müssen im options-Objekt vorhanden sein.', options);
    }

    // Stylesheet wurde bereits geladen oder wird bereits geladen.
    // In diesem Fall keinen weiteren Request auslösen.
    if (document.getElementById(options.id)) {
      if (typeof options.callback === 'function') {
        options.callback.call(undefined, true);
      }

      return;
    }

    var link = document.createElement('link');
    link.id = options.id;
    link.href = options.src;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.media = options.media || 'screen';

    if (options.fetchpriority) {
      link.fetchpriority = options.fetchpriority;
    }

    if (typeof options.callback === 'function') {
      link.onload = options.callback;
    }

    // Das Link-Element wird im Head eingefügt und startet
    // dadurch den Download des Stylesheets.
    document.head.appendChild(link);
  };

  /**
   * Berechnet die CRC32-Prüfsumme eines Strings.
   *
   * Die Prüfsumme wird verwendet, um aus Asset-Pfaden
   * kompakte und reproduzierbare IDs zu erzeugen.
   *
   * Beispiel:
   * "swr-neu-search.min.js"
   * -> 1234567890
   *
   * @param {string} str Eingabestring.
   * @returns {number} CRC32-Prüfsumme als positive Ganzzahl.
   * @private
   */
  function crc32 (str) {
    var crc = -1;

    for (var i = 0, iTop = str.length; i < iTop; i++) {
      crc = (crc >>> 8) ^ crc32.b_table[(crc ^ str.charCodeAt(i)) & 0xFF];
    }

    return (crc ^ (-1)) >>> 0;
  }

  // Vorgefertigte Lookup-Tabelle zur Beschleunigung der CRC32-Berechnung.
  crc32.a_table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

  // Umwandlung der Tabellenwerte von Hex-Strings in numerische Integer-Werte.
  crc32.b_table = crc32.a_table.split(' ').map(function (s) {
    return parseInt(s, 16);
  });

  /**
   * Bestimmt den rootMargin-Wert für IntersectionObserver
   * abhängig von der verfügbaren Netzwerkverbindung.
   *
   * Auf langsamen Verbindungen werden Assets früher geladen,
   * um die wahrgenommene Ladezeit für Benutzer zu reduzieren.
   *
   * - normale Verbindung: 625px
   * - langsame Verbindung oder Save-Data: 1250px
   *
   * @returns {string} Root-Margin für den IntersectionObserver.
   */
  function rootMargin () {
    var connection = navigator.connection;
    var margin = '625px'; // Standardwert für normale Netzwerkverbindungen.

    if (connection) {
      if (['slow-2g', '2g', '3g'].includes(connection.effectiveType) || connection.saveData) {
        // Bei langsamen Verbindungen oder aktiviertem
        // Datensparmodus früher mit dem Vorladen beginnen.
        margin = '1250px';
      }
    }

    return margin;
  }

  /**
   * Lädt die in einer Konfiguration definierten CSS- und JavaScript-Assets.
   *
   * Für jedes Asset wird ein eigener Ladevorgang gestartet. Anschließend
   * wird auf den Abschluss aller Ladeversuche gewartet.
   *
   * CSS-Dateien können optional zusammen mit einem Media-Typ definiert werden.
   * JavaScript-Dateien können optional zusätzliche Attribute wie den Script-Typ
   * (z.B. `module`) enthalten.
   *
   * @param {{
   *   assets: {
   *     css?: Array<string | [string, string]>,
   *     js?: Array<string | {src: string, type?: string}>
   *   },
   *   fetchPriority?: 'high' | 'low' | 'auto'
   * }} config
   *        Konfiguration der zu ladenden Assets.
   *
   * @param {function(boolean): void} [callback]
   *        Optionale Callback-Funktion, die nach Abschluss aller Ladeversuche
   *        aufgerufen wird.
   *        Der Callback erhält:
   *        - `true`, wenn alle Assets erfolgreich geladen wurden.
   *        - `false`, wenn mindestens ein Asset nicht geladen werden konnte.
   *
   * @private
   */
  var loadAssets = function (config, callback) {
    var assets = config.assets;
    var fetchPriority = config.fetchPriority;
    var promises = [];

    if (enableDebugMode) {
      console.debug('[SWR.Deferred] loadAssets aufgerufen mit Konfiguration:', config);
    }

    // CSS-Assets laden
    if (assets.css?.length) {
      assets.css.forEach(function (style) {
        var media = 'screen';

        if (Array.isArray(style)) {
          media = style[1];
          style = style[0];
        }

        if (enableDebugMode) {
          console.debug('[SWR.Deferred] Lade CSS:', style, 'mit Media-Typ:', media);
        }

        var promise = new Promise(function (resolve, reject) {
          try {
            loadCss({
              id: crc32(style),
              src: SWRNEU.Util.getAssetBaseUrl() + '/assets/css/' + style,
              callback: resolve,
              type: media,
              fetchpriority: fetchPriority,
            });
          } catch (e) {
            reject(e);
          }
        });

        promises.push(promise);
      });
    }

    // JavaScript-Assets laden
    if (assets.js?.length) {
      assets.js.forEach(function (script) {
        var src = typeof script === 'string' ? script : script.src;
        var type = typeof script === 'object' ? script.type : undefined;

        if (enableDebugMode) {
          console.debug('[SWR.Deferred] Lade JS:', src, type ?? 'mit Typ:' + type);
        }

        var promise = new Promise(function (resolve, reject) {
          try {
            loadScript({
              id: crc32(src),
              src: SWRNEU.Util.getAssetBaseUrl() + '/assets/js/' + src,
              callback: resolve,
              type: type,
              fetchpriority: fetchPriority,
            });
          } catch (e) {
            reject(e);
          }
        });

        promises.push(promise);
      });
    }

    // Auf den Abschluss aller Ladeversuche warten.
    // Promise.allSettled wird verwendet, damit auch bei einzelnen
    // Ladefehlern eine Gesamtauswertung und der Callback-Aufruf erfolgt.
    Promise.allSettled(promises)
      .then(function (results) {
        var allSuccessful = true;

        results.forEach(function (result) {
          if (result.status === 'rejected') {
            allSuccessful = false;

            if (enableDebugMode) {
              console.error('[SWR.Deferred] Ein Asset konnte nicht geladen werden:', result.reason);
            }
          }
        });

        if ('function' === typeof callback) {
          try {
            // Der Callback erhält den Gesamtstatus aller Ladevorgänge.
            // `true` bedeutet, dass alle Assets erfolgreich geladen wurden.
            callback.call(undefined, allSuccessful);
          } catch (e) {
            // Fängt Fehler ab, die innerhalb der Callback-Funktion selbst auftreten.
            if (enableDebugMode) {
              console.error('[SWR.Deferred] Fehler im Callback nach dem Laden der Assets:', e);
            }
          }
        }
      });
  };

  /**
   * Enthält alle Selektoren, deren Assets bereits geladen wurden.
   *
   * Die Assets werden pro Selektor nur einmal geladen, unabhängig davon,
   * wie viele passende Elemente auf der Seite vorhanden sind.
   *
   * @type {Set<string>}
   */
  var loadedSelectors = new Set();

  /**
   * Speichert registrierte IntersectionObserver pro Element und Selektor.
   *
   * Ein Element kann mehreren konfigurierten Selektoren entsprechen.
   * Daher werden die Observer verschachtelt gespeichert:
   *
   * Element -> Selektor -> IntersectionObserver
   *
   * Dadurch kann für dieselbe Element-/Selektor-Kombination verhindert
   * werden, dass mehrere Observer registriert werden, während gleichzeitig
   * mehrere Selektoren pro Element unterstützt werden.
   *
   * @type {Map<Element, Map<string, IntersectionObserver>>}
   */
  var elementObservers = new Map();

  /**
   * Analysiert einen DOM-Kontext auf konfigurierte Selektoren und lädt
   * die zugehörigen Assets (CSS/JS) bei Bedarf nach.
   *
   * Für jeden Selektor werden passende Elemente im übergebenen Kontext
   * oder im gesamten Dokument gesucht.
   *
   * Je nach Konfiguration werden die Assets:
   * - sofort geladen (`observe: false`),
   * - oder erst geladen, sobald ein passendes Element sichtbar wird
   * (`observe: true`).
   *
   * Bereits geladene Selektoren werden übersprungen, um mehrfaches
   * Nachladen derselben Assets zu verhindern.
   *
   * Die Funktion wird sowohl beim initialen Seitenaufbau als auch nach
   * dynamischen DOM-Änderungen (z.B. PJAX oder MutationObserver)
   * aufgerufen.
   *
   * @param {jQuery} [$context]
   * Optionaler Suchkontext. Wird kein Kontext übergeben,
   * wird das gesamte Dokument durchsucht.
   * @private
   */
  var checkAndLoad = function ($context) {
    var currentRootMargin = rootMargin();

    if (enableDebugMode) {
      console.debug('[SWR.Deferred] checkAndLoad ausgelöst.', 'Kontext:', $context || '$()');
    }

    Object.keys(configs).forEach(function (selector) {
      // Die Assets für diesen Selektor wurden bereits geladen.
      // Weitere Prüfungen sind nicht erforderlich.
      if (loadedSelectors.has(selector)) {
        return;
      }

      // Suche nach passenden Elementen.
      // Bei einem übergebenen Kontext werden sowohl dessen Nachfahren
      // als auch der Kontext selbst berücksichtigt.
      var $elements = $context ? $context.find(selector).addBack(selector) : $(selector);

      $elements.each(function () {
        var element = this;

        // Während der Iteration könnte ein anderes Element desselben
        // Selektors die Assets bereits geladen haben.
        if (loadedSelectors.has(selector)) {
          return;
        }

        // Für dieselbe Element-/Selektor-Kombination wurde bereits
        // ein Observer registriert.
        if (elementObservers.has(element) && elementObservers.get(element).has(selector)) {
          return;
        }

        if (!configs[selector].observe) {
          // Dieser Selektor soll nicht beobachtet werden.
          // Die Assets werden sofort geladen, sobald wenigstens ein
          // passendes Element gefunden wurde.

          if (enableDebugMode) {
            console.debug('[SWR.Deferred] Selektor gefunden, für den auch, wenn er nicht sichtbar ist, geladen werden soll:', selector);
          }

          if (!loadedSelectors.has(selector)) {
            loadedSelectors.add(selector);
            loadAssets({
              assets: configs[selector],
              fetchPriority: 'high'
            });
          }

          return;
        }

        if (enableDebugMode) {
          console.debug('[SWR.Deferred] Selektor gefunden, für den ein Observer registriert wird:', selector);
        }

        // Für beobachtete Selektoren wird ein IntersectionObserver
        // eingerichtet. Die Assets werden geladen, sobald eines der
        // passenden Elemente sichtbar wird.
        var observer = new IntersectionObserver(function (entries, observerInstance) {
          entries.forEach(function (entry) {
            // Elemente mit display: contents besitzen keine eigene Layout-Box und werden
            // vom IntersectionObserver nicht zuverlässig erkannt.
            // In diesem Fall wird stattdessen geprüft, ob eines der Kindelemente sichtbar ist.
            const isContents = getComputedStyle(entry.target).display === 'contents';

            if (entry.isIntersecting || entry.intersectionRatio > 0 || (isContents && hasVisibleChild(entry.target))) {
              var rect = entry.boundingClientRect;
              var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

              // Prüfen, ob sich das Element aktuell tatsächlich
              // im sichtbaren Bereich befindet.
              var isActuallyInViewport = (rect.top < viewportHeight && rect.bottom > 0);

              // Elemente innerhalb des rootMargins, aber noch außerhalb
              // des Viewports, erhalten eine niedrigere Priorität.
              var currentPriority = isActuallyInViewport ? 'high' : 'low';

              // Die Assets werden nur einmal pro Selektor geladen,
              // unabhängig davon, wie viele passende Elemente existieren.
              if (!loadedSelectors.has(selector)) {
                loadedSelectors.add(selector);
                loadAssets({
                  assets: configs[selector],
                  fetchPriority: currentPriority
                });
              }

              // Dieses Element muss nicht weiter beobachtet werden,
              // da die Assets für den Selektor bereits geladen wurden.
              observerInstance.unobserve(entry.target);

              // Observer-Registrierung für diese konkrete
              // Element-/Selektor-Kombination entfernen.
              const selectorObservers = elementObservers.get(entry.target);

              if (selectorObservers) {
                selectorObservers.delete(selector);

                // Wurden keine weiteren Selektoren für dieses Element
                // registriert, kann der Eintrag vollständig entfernt werden.
                if (selectorObservers.size === 0) {
                  elementObservers.delete(entry.target);
                }
              }
            }
          });
        }, {
          root: null, // Der Viewport ist der Root
          rootMargin: currentRootMargin,
          threshold: 0
        });

        observer.observe(element);

        // Für ein einzelnes Element können mehrere Observer existieren,
        // da ein Element mehrere konfigurierte Selektoren erfüllen kann.
        if (!elementObservers.has(element)) {
          elementObservers.set(element, new Map());
        }

        elementObservers.get(element).set(selector, observer);
      });
    });
  };

  /**
   * Prüft, ob mindestens eines der direkten Kindelemente sichtbar ist.
   *
   * Dies wird für Elemente mit `display: contents` benötigt, da diese selbst
   * keine eigene Box im Layout besitzen und daher vom IntersectionObserver
   * häufig nicht als sichtbar erkannt werden können.
   *
   * Ein Kindelement wird als sichtbar betrachtet, wenn:
   * - es eine Breite größer 0 besitzt,
   * - es eine Höhe größer 0 besitzt,
   * - sein unterer Rand innerhalb oder unterhalb des Viewports liegt,
   * - sein oberer Rand innerhalb oder oberhalb des Viewports liegt.
   *
   * @param {Element} element Das zu prüfende Elternelement.
   * @returns {boolean} `true`, wenn mindestens ein sichtbares Kindelement
   * gefunden wurde, andernfalls `false`.
   */
  function hasVisibleChild (element) {
    return [...element.children].some(child => {
      const rect = child.getBoundingClientRect();

      return (
        // Element besitzt eine sichtbare Größe
        rect.width > 0 && rect.height > 0 &&

        // Element befindet sich mindestens teilweise im Viewport
        rect.bottom > 0 && rect.top < window.innerHeight);
    });
  }

  // Debouncete Version von checkAndLoad für den MutationObserver.
  var debouncedCheckAndLoad = SWRNEU.Util.debounce(checkAndLoad, 50); // 50ms als Standardverzögerung

  // Lade die "lazy" Skripte, die immer benötigt werden.
  loadAssets({ assets: { js: lazyScripts } });

  // Initiale Prüfung beim Laden der Seite.
  if (enableDebugMode) {
    console.debug('[SWR.Deferred] Starte initiale Prüfung.');
  }

  checkAndLoad();

  // Verzögerte Prüfung für später initialisierte Elemente.
  window.setTimeout(function () {
    if (enableDebugMode) {
      console.debug('[SWR.Deferred] Starte verzögerte initiale Prüfung.');
    }
    checkAndLoad();
  }, 500);

  // Erneute Prüfung nach einer PJAX-Navigation.
  $(document).on('pjax:end', function (event, _xhr, options) {
    if (enableDebugMode) {
      console.debug('[SWR.Deferred] pjax:end: Navigation abgeschlossen, starte Prüfung.');
    }

    // Die debouncete Funktion reagiert auf den neuen Kontext und bündelt die verzögerte Prüfung.
    debouncedCheckAndLoad($(options.container));
  });

  /**
   * Wenn Elemente beispielsweise per JS dazukommen, werden die entsprechenden Assets nachgeladen.
   * Der debouncete Aufruf von checkAndLoad bündelt mehrere, schnell
   * aufeinanderfolgende Änderungen zu einer einzigen Prüfung.
   * @private
   */
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var nodesWithChangedAttributes = []; // Elemente, deren Klassenattribute verändert wurden (z. B. "collapse" → "collapse show").
      var addedNodes = []; // Neu in das DOM eingefügte Elemente.
      var changedNodes = []; // Zusammengeführte Liste aller relevanten Änderungen, die anschließend erneut geprüft werden sollen.

      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // Reagiere auf Änderungen des class-Attributs.
          // Dadurch werden auch Komponenten erfasst, die bereits
          // im DOM vorhanden sind und erst später per CSS-Klasse
          // sichtbar oder aktiv geschaltet werden.
          nodesWithChangedAttributes.push(mutation.target);
        }

        if (mutation.type === 'childList') {
          // Reagiere auf neu hinzugefügte DOM-Knoten.
          if (0 < mutation.addedNodes.length) {
            // Wir fügen nur Element-Nodes hinzu, da Text-Nodes für Selektoren irrelevant sind.
            for (var i = 0; i < mutation.addedNodes.length; i++) {
              var node = mutation.addedNodes[i];

              if (1 === node.nodeType) { // Node.ELEMENT_NODE
                addedNodes.push(node);
              }
            }
          }
        }
      });

      // Fasse alle relevanten Änderungen zusammen:
      // - neue Elemente
      // - Elemente mit geänderten Klassen
      changedNodes = nodesWithChangedAttributes.concat(addedNodes);

      if (0 < addedNodes.length) {
        // Feuere jQuery-Event für andere Module, die auf DOM-Änderungen reagieren möchten
        $(document).trigger('swr:dom-change:addedNodes', {
          addedNodes: addedNodes
        });
      }

      if (0 < changedNodes.length) {
        // Starte eine erneute Prüfung der konfigurierten Selektoren.
        // Dies ist notwendig, da Elemente entweder neu hinzugefügt
        // wurden oder durch Klassenänderungen nun erstmals einen
        // konfigurierten Selektor erfüllen können.
        debouncedCheckAndLoad();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true, // Wichtig, um auch Änderungen in tieferen DOM-Ebenen zu erfassen.
      attributes: true, // Beobachte zusätzlich Attributänderungen.
      attributeFilter: ['class'] // Beschränke die Beobachtung auf Klassenänderungen, um unnötige Mutation-Events zu vermeiden.
    });
  }

  /**
   * Eine vorberechnete Map für schnellen Zugriff in der force()-Methode.
   * Bildet einzelne Selektoren direkt auf ihre Konfiguration ab.
   * @type {Map<string, {css?: (string | string[])[], js?: string[]}>}
   * @private
   */
  var selectorToConfigMap = new Map();

  Object.keys(configs).forEach(function (compositeSelector) {
    var config = configs[compositeSelector];

    compositeSelector.toLowerCase().split(',').forEach(function (singleSelector) {
      selectorToConfigMap.set(singleSelector.trim(), config);
    });
  });

  /**
   * Öffentliches API des Moduls.
   */
  return {
    /**
     * Erzwingt das Laden von Assets für einen bestimmten Selektor.
     * Diese Methode ist nützlich, wenn Skripte programmgesteuert geladen werden müssen,
     * bevor das zugehörige Element im DOM sichtbar ist.
     * @param {string} selector - Ein einzelner, einfacher Selektor (keine Komma-getrennte Liste), dessen zugehörige Assets geladen werden sollen.
     * @param {function(boolean): void} [callback] - Eine optionale Callback-Funktion, die nach dem Laden ausgeführt wird.
     * @public
     */
    force: function (selector, callback) {
      var requestedSelector = selector.toLowerCase();
      var config = selectorToConfigMap.get(requestedSelector);

      if (enableDebugMode) {
        console.debug('[SWR.Deferred] force() aufgerufen für Selektor:', requestedSelector);
      }

      if (config) {
        if (loadedSelectors.has(requestedSelector)) {
          if (typeof callback === 'function') {
            callback.call(undefined, true); // Gehe von Erfolg aus, wenn bereits geladen
          }

          return;
        }

        if (enableDebugMode) {
          console.debug('[SWR.Deferred] Passende Konfiguration für force() gefunden, lade Assets:', config);
        }

        loadedSelectors.add(requestedSelector); // Als geladen markieren
        loadAssets({
          assets: config,
          fetchPriority: 'high' // "force" impliziert eine hohe Priorität
        }, callback);
      } else {
        if (typeof callback === 'function') {
          callback.call(undefined, false); // Misserfolg anzeigen, wenn keine Konfiguration gefunden
        }

        if (enableDebugMode) {
          console.debug('[SWR.Deferred] Für den force() Aufruf mit Selektor "' + requestedSelector + '" wurde keine passende Konfiguration gefunden.');
        }
      }
    }
  };
})(window.jQuery);
